import { GuideTypes } from "../models";
import { MobileDeviceValues } from "@trailhead/smart-setup-core";
import {
  androidToSamsungSetupLostPhone,
  androidToSamsungSetupWithPhone,
  backupAndroidContent,
  backupIphone,
  iphoneSetupContentLostPhone,
  iphoneSetupContentWithPhone,
  iphoneToIphoneSetupWithPhone,
  iphoneToSamsungSetupWithPhone,
  samsungToAndroidWithPhone,
  iphoneToAndroidSetupWithPhone,
  iphoneToSamsungSetupLostPhone,
  iphoneToAndroidSetupLostPhone,
  sendBackContent,
  iphoneSendBackContent,
  eSIMWizardActivationContent,
} from "./common";

export const ATTContent = {
  [GuideTypes.BACKUP]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
      },
      content: backupIphone,
    },
    backupAndroidContent(MobileDeviceValues.Samsung),
    backupAndroidContent(MobileDeviceValues.OtherAndroid),
    backupAndroidContent(MobileDeviceValues.Pixel),
  ],
  [GuideTypes.ACTIVATE]: [eSIMWizardActivationContent()],

  [GuideTypes.SETUP]: [
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneToIphoneSetupWithPhone,
    }, //iphone to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: iphoneToSamsungSetupWithPhone,
    }, //iphone to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: iphoneToSamsungSetupLostPhone,
    }, //iphone to samsung lost phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: iphoneToAndroidSetupWithPhone,
    }, //iphone to android with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.iPhone,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: iphoneToAndroidSetupLostPhone,
    }, //iphone to android lost phone

    //--------------------------------------------

    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: androidToSamsungSetupWithPhone,
    }, //samsung to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneSetupContentWithPhone,
    }, //samsung to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: samsungToAndroidWithPhone,
    }, //samsung to android with phone

    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: true,
      },
      content: iphoneSetupContentWithPhone,
    }, //android to iphone with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: true,
      },
      content: androidToSamsungSetupWithPhone,
    }, //android to samsung with phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: true,
      },
      content: samsungToAndroidWithPhone,
    }, //android to android with phone

    {
      criteria: {
        newPhone: MobileDeviceValues.iPhone,
        oldDeviceFunctional: false,
      },
      content: iphoneSetupContentLostPhone,
    }, //x to iphone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: androidToSamsungSetupLostPhone,
    }, //android to samsung WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.Samsung,
        oldDeviceFunctional: false,
      },
      content: androidToSamsungSetupLostPhone,
    }, //samsung to samsung WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.Samsung,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: androidToSamsungSetupLostPhone,
    }, //samsung to android WITHOUT phone
    {
      criteria: {
        oldPhone: MobileDeviceValues.OtherAndroid,
        newPhone: MobileDeviceValues.OtherAndroid,
        oldDeviceFunctional: false,
      },
      content: androidToSamsungSetupLostPhone,
    }, //android to android WITHOUT phone
  ],
  [GuideTypes.SEND_BACK]: [
    iphoneSendBackContent,
    sendBackContent(MobileDeviceValues.Samsung),
    sendBackContent(MobileDeviceValues.OtherAndroid),
    sendBackContent(MobileDeviceValues.Pixel),
  ],
};
